import { DatePipe } from '@angular/common';
import { Component, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { GenerateEmissionReportComponent } from 'src/app/shared/components/generate-emission-report/generate-emission-report.component';
import { ToastrService } from 'ngx-toastr';

import {
  getmonths,
  getShipNameOptions,
  gettypeofreport,
  getvesselname
} from 'src/app/shared/helpers/dropdown-options';

import { EmissionService } from 'src/app/shared/service/emission-service/emission.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-table-view-cii',
  templateUrl: './table-view-cii.component.html',
  styleUrls: ['./table-view-cii.component.scss'],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }]
})
export class TableViewCIIComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatSort) sort!: MatSort;

  myreportForm: FormGroup;

  monthOptions: any;
  shipnameoptions: any;
  vesselnameoptions: any;
  typeofreportoptions: string[];

  elements: any[] = [];
  paginatedData: any[] = [];

  currentPage = 0;
  itemsPerPage = 100;
 slideClass = 'page-enter'; 
  vesselNameSuggestions: any[] = [];
  isLoading = false;
  imo!: string;
  vesselName: string = '';
  private destroy$ = new Subject<void>();
  reportOptions = [
    { label: 'Average Temp Forecast', value: 'avg_temp_forecast' },
    { label: 'Tank Temp Forecast', value: 'tank_temp_forecast' },
    { label: 'Heat Plan', value: 'heat_plan' },
    { label: 'Bunker Report', value: 'bunker_forecast' }
  ];
  subusername: any;

  constructor(
    private fb: FormBuilder,
    private emissionService: EmissionService,
    private toastr: ToastrService,
    private router: Router,
    private datePipe: DatePipe,
    private overlayService: OverlapService,
    private requestFormService: RequestFormService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
  ) {
    this.myreportForm = this.fb.group({
      from_date: [''],
      to_date: [''],
      voyage_numbers: [[]],
      port: [''],
      month: ['']
    });

    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.vesselnameoptions = getvesselname();
    this.typeofreportoptions = gettypeofreport();
  }

  ngOnInit(): void {
     this.subusername = localStorage.getItem('loginPic') ?? '';
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const imo = params.get('imo');

      if (imo) {
        this.imo = imo;
        this.fetchReportTableData(this.imo);
      } else {
        this.toastr.error('IMO not found');
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }

  fetchReportTableData(imo: string): void {
    this.isLoading = true;

    this.emissionService.getCIITableDataByIMO(imo).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.elements = res?.voyages || [];
        const originalImo = res?.imo_number
        if(this.subusername?.toLowerCase() === 'demo'){
                this.vesselName = originalImo === 9399480 ? 'Vessel 1' : 'Vessel 2';
        }else{
             this.vesselName = this.elements[0]?.vessel_name || '';
        }
       

        this.populateFilterOptions();

        this.currentPage = 0;
        this.paginateData();
      },
      error: () => {
        this.isLoading = false;
        this.toastr.error('Failed to load voyage data');
      }
    });
  }

  uniqueVoyages: any[] = [];
  uniquePorts: string[] = [];

  populateFilterOptions(): void {
    const voyages = new Set<string>();
    const ports = new Set<string>();

    this.elements.forEach((v: any) => {
      if (v.voyage_number) voyages.add(v.voyage_number);
      if (v.from_port) ports.add(v.from_port);
      if (v.to_port) ports.add(v.to_port);
    });

    this.uniqueVoyages = Array.from(voyages).sort();
    this.uniquePorts = Array.from(ports).sort();
  }





  paginateData(): void {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  goToNextPage() {
    this.slideClass = 'page-exit';

    setTimeout(() => {
      this.router.navigate(['/E-cii']);
    }, 500);   
  }
  sortData(sort: Sort): void {
    const data = [...this.paginatedData];

    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    const isAsc = sort.direction === 'asc';

    this.paginatedData = data.sort((a, b) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    });
  }

  filterClick(): void {
    const { from_date, to_date, voyage_numbers, port, month } = this.myreportForm.value;

    this.emissionService.getCIITableDataByIMO(this.imo).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        let filtered = res?.voyages || [];

        // Date Range
        if (from_date && to_date) {
          const start = new Date(from_date);
          const end = new Date(to_date);
          filtered = filtered.filter((v: any) => {
            const cosp = new Date(v.cosp_timestamp);
            return cosp >= start && cosp <= end;
          });
        }

        // Voyage Numbers (Multi-select)
        if (voyage_numbers && voyage_numbers.length > 0) {
          filtered = filtered.filter((v: any) => voyage_numbers.includes(v.voyage_number));
        }

        // Port
        if (port) {
          const p = port.toLowerCase();
          filtered = filtered.filter((v: any) => 
            (v.from_port && v.from_port.toLowerCase().includes(p)) || 
            (v.to_port && v.to_port.toLowerCase().includes(p))
          );
        }

        // Month
        if (month) {
          filtered = filtered.filter((v: any) => {
            if (!v.cosp_timestamp) return false;
            const m = new Date(v.cosp_timestamp).toLocaleString('default', { month: 'long' });
            return m === month;
          });
        }

        this.elements = filtered;
        this.currentPage = 0;
        this.paginateData();
      }
    });
  }

  clearClick(): void {
    this.myreportForm.reset({
      from_date: '',
      to_date: '',
      voyage_numbers: [],
      port: '',
      month: ''
    });
    this.fetchReportTableData(this.imo);
  }

  printFinalReport(row: any): void {
    const payload = {
      vessel_imo: row.ship_imo,
      voyage_no: row.voyage_no
    };

    this.emissionService.printFinalReport(payload).subscribe(
      (res: any) => {
        this.overlayService.showPdf(res);
      },
      () => {
        this.toastr.error('Report Not Found');
      }
    );
  }

  filterShipNames(event: any): void {
    const input = event.target.value.toLowerCase();
    this.vesselNameSuggestions = this.vesselnameoptions.filter(
      (item: any) => item.ship_name.toLowerCase().includes(input)
    );
  }

  goBack(): void {
    this.router.navigate(['/ch-graph']);
  }

  isDarkMode(): boolean {
    return this.requestFormService.isDarkMode();
  }

  downloadClick() { }

  openGenerateReportPopup(row: any) {
    this.dialog.open(GenerateEmissionReportComponent, {
      width: '560px',
      data: { ...row, reportType: 'CII' },
      disableClose: true,
    });
  }
}
